import * as Sentry from "@sentry/react";

/**
 * Records a usage event as a Sentry log. Fire-and-forget: it never throws,
 * so a tracking failure can't affect the action being tracked.
 * @param name - The event name, e.g. "csv_downloaded"
 * @param attributes - Extra searchable attributes for the event
 */
export function trackEvent(
  name: string,
  attributes: Record<string, string | number | boolean | null | undefined> = {},
): void {
  try {
    Sentry.logger.info(name, {
      ...attributes,
      page: window.location.pathname,
    });
  } catch {
    // Tracking is best-effort
  }
}
